import React from 'react';
import Button from '../../ui/button';

import { useTranslation } from 'react-i18next';

const InsufPermition = ({ onClose }) => {
    const {t} = useTranslation('common');
    const closeModal = (refresh=false) => {
        onClose(refresh);
    };

    return (
        <div className="w-auto m-2 bg-white  max-md:p-3 p-8 rounded-3xl shadow-lg">
            <p className="flex justify-center  text-xl  text-[#4C4C66] font-bold mb-10">{t('insufition_permition')}</p>
            <p className="flex justify-center  text-md text-[#4C4C66] font-normal mb-4">{t('you_need_to_contact_your_site_administrator_to_add_new_site')}</p>
            <div className=' flex justify-center mt-10 space-x-5'>
                <Button type="reset" onClick={closeModal} size="large" color="cancel" >{t('close')}</Button>
            </div>
        </div>
    );
};

export default InsufPermition;
